import { render, staticRenderFns } from "./FeedbackComponent.vue?vue&type=template&id=1f81a0e2&scoped=true&"
import script from "./FeedbackComponent.vue?vue&type=script&lang=ts&"
export * from "./FeedbackComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackComponent.vue?vue&type=style&index=0&id=1f81a0e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81a0e2",
  null
  
)

export default component.exports